import {
    Dispatch,
    RefObject,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from 'react'

export interface UseComponentVisibleValue {
    ref: RefObject<HTMLAnchorElement>
    isComponentVisible: boolean
    setIsComponentVisible: Dispatch<SetStateAction<boolean>>
}

export default function useComponentVisible(
    initialIsVisible: boolean
): UseComponentVisibleValue {
    const [isComponentVisible, setIsComponentVisible] =
        useState(initialIsVisible)
    const ref = useRef<HTMLDivElement>(null)

    const handleClickOutside = (event: Event) => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
            setIsComponentVisible(false)
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)

        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    })

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return {ref, isComponentVisible, setIsComponentVisible}
}
